export default "__VITE_PUBLIC_ASSET__33c90506__"